import { storeSelectedTrek } from './selectedTrekActions';
import { USE_TREK_AS_TEMPLATE_SUCCESS } from './types';
import api from '../../lib/api';
import endpoints from '../../lib/endpoints';
import { getToastMsg } from '../../components/ErrorMessage';
import { getNewTrekName } from '../../lib/utils';

export const useTrekAsTemplate = (trekId, patchObj) => {
  return async (dispatch, getState) => {
    const {
      selectedTrek: { trek },
      user,
    } = getState();
    const trekName = trek.name;
    const creatorName = user.name;

    try {
      const { data } = await api.put(endpoints.treks.forkTrek(trekId), {
        ...patchObj,
        name: getNewTrekName(trekName, creatorName),
      });
      dispatch(onForkSucces());
      dispatch(storeSelectedTrek(data));
      getToastMsg({ type: 'useAsTemplate', status: 'success' });
      return data;
    } catch (err) {
      getToastMsg({ type: 'useAsTemplate', status: 'error' });
      throw new Error('Faild To Fork Trek');
    }
  };
};

const onForkSucces = () => ({
  type: USE_TREK_AS_TEMPLATE_SUCCESS,
});



// WEBPACK FOOTER //
// ./src/redux/actions/useAsTemplateActions.js